import Decimal from 'decimal.js';

export default function toPriceDisplay(amount, customSeparator = null) {
  const display = `R$ ${Decimal(amount).toFixed(2)}`;
  return customSeparator ? display.replace('.', customSeparator) : display;
}
